'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = exports.Modal = exports.Portal = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * @param {string} className Base classname
 * @param {object} (state) Modal state
 * @param {object} (props) Config classes
 * @return {string} Full classname
 */


var getClassName = function getClassName(className, _ref, _ref2) {
  var open = _ref.open,
      afterOpen = _ref.afterOpen,
      hiding = _ref.hiding;
  var openClass = _ref2.openClass,
      visibleClass = _ref2.visibleClass,
      hidingClass = _ref2.hidingClass;
  return className + (open ? ' ' + (openClass || 'is-open') : '') + (afterOpen ? ' ' + (visibleClass || 'is-visible') : '') + (hiding ? ' ' + (hidingClass || 'is-hiding') : '');
};
/**
 * @param {string} className
 * @param {object} style
 */


var Portal = exports.Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    _classCallCheck(this, Portal);

    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass(Portal, [{
    key: 'getChildren',
    value: function getChildren() {
      var attrs = {
        className: this.props.className,
        style: this.props.style
      };
      return _react2.default.createElement('section', attrs, this.props.children);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.portalNode = document.body.appendChild(document.createElement('div'));
      this.portal = (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, this.getChildren(), this.portalNode);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.portal = (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, this.getChildren(), this.portalNode);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _reactDom.unmountComponentAtNode)(this.portalNode);
      document.body.removeChild(this.portalNode);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Portal;
}(_react2.default.Component);

var Modal = exports.Modal = function (_React$Component2) {
  _inherits(Modal, _React$Component2);

  function Modal(props) {
    _classCallCheck(this, Modal);

    var _this2 = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this2.state = {
      hiding: false,
      open: _this2.props.open,
      afterOpen: false
    };
    return _this2;
  }

  _createClass(Modal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      var _this3 = this;

      var open = props.open,
          onOpen = props.onOpen,
          onClose = props.onClose;

      if (open && !this.state.open) {
        onOpen && onOpen();
        document.body.classList.add(this.props.bodyClass);
        this.setState({
          open: true
        }, function () {
          return setTimeout(function () {
            return _this3.setState({
              afterOpen: true
            });
          }, 0);
        });
      } else if (!open && this.state.open) {
        onClose && onClose();
        this.setState({
          hiding: true
        }, function () {
          setTimeout(function () {
            document.body.classList.remove(_this3.props.bodyClass);

            _this3.setState({
              open: false,
              hiding: false,
              afterOpen: false
            });
          }, _this3.props.closeTimeout);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          onClick = _props.onClick,
          portalClassName = _props.portalClassName,
          portalStyle = _props.portalStyle,
          overlayClassName = _props.overlayClassName,
          overlayStyle = _props.overlayStyle;
      var modal = {
        className: getClassName(className, this.state, this.props),
        style: style
      };
      var portal = {
        className: portalClassName,
        style: portalStyle
      };
      var overlay = {
        style: overlayStyle || {
          position: 'fixed',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 0
        },
        onClick: onClick,
        className: overlayClassName
      };
      return _react2.default.createElement(Portal, portal, _react2.default.createElement('div', modal, _react2.default.createElement('div', overlay), _react2.default.cloneElement(this.props.children, Object.assign({}, this.props.children.props, this.state))));
    }
  }]);

  return Modal;
}(_react2.default.Component);

Modal.defaultProps = {
  className: 'modal',
  closeTimeout: 500,
  bodyClass: 'modal-is-open',
  portalClassName: 'modal-portal',
  overlayClassName: 'modal__overlay'
};

var Content = function Content(_ref3) {
  var children = _ref3.children,
      _ref3$className = _ref3.className,
      className = _ref3$className === undefined ? 'modal__content' : _ref3$className,
      style = _ref3.style,
      props = _objectWithoutProperties(_ref3, ['children', 'className', 'style']);

  var attrs = {
    className: getClassName(className, props, props),
    style: style
  };
  return _react2.default.createElement('div', attrs, children);
};

exports.Content = Content;